export const secondaryPathnames = {
  "/cookies": {
    de: "/cookies",
    fr: "/cookies",
    es: "/cookies",
    pt: "/cookies",
    it: "/cookie",
    nl: "/cookies",
    ru: "/cookies",
    ar: "/cookies",
    hi: "/cookies",
    zh: "/cookies",
    ja: "/cookies",
    ko: "/cookies",
    id: "/cookies",
    tr: "/cerezler",
    hu: "/sutik",
    pl: "/cookies",
  },
  "/feature-requests": {
    en: "/feature-requests",
    de: "/feature-anfragen",
    fr: "/demandes-fonctionnalites",
    es: "/solicitudes-caracteristicas",
    pt: "/solicitacoes-recursos",
    it: "/richieste-funzionalita",
    nl: "/feature-verzoeken",
    ru: "/zaprosy-funkcij",
    ar: "/talabat-alwazif",
    hi: "/suvidha-anurodh",
    zh: "/gongneng-yaoqiu",
    ja: "/kinou-yokyu",
    ko: "/gineung-yoggu",
    id: "/permintaan-fitur",
    tr: "/ozellik-talepleri",
    hu: "/funkcio-kerelemek",
    pl: "/zgloszenia-funkcji",
  },
  "/bug-reports": {
    en: "/bug-reports",
    de: "/fehlerberichte",
    fr: "/rapports-bugs",
    es: "/informes-errores",
    pt: "/relatorios-bugs",
    it: "/segnalazioni-bug",
    nl: "/bug-rapporten",
    ru: "/otchety-ob-oshibkah",
    ar: "/taqrirat-alashkal",
    hi: "/bug-raport",
    zh: "/bug-baogao",
    ja: "/bagu-repo",
    ko: "/bagu-ripo",
    id: "/laporan-bug",
    tr: "/bug-raporlari",
    hu: "/hiba-jelentesek",
    pl: "/raporty-bugow",
  },
  "/feature-requests/create": {
    en: "/feature-requests/create",
    de: "/feature-anfragen/erstellen",
    fr: "/demandes-fonctionnalites/creer",
    es: "/solicitudes-caracteristicas/crear",
    pt: "/solicitacoes-recursos/criar",
    it: "/richieste-funzionalita/crea",
    nl: "/feature-verzoeken/aanmaken",
    ru: "/zaprosy-funkcij/sozdat",
    ar: "/talabat-alwazif/ansh",
    hi: "/suvidha-anurodh/banaye",
    zh: "/gongneng-yaoqiu/chuangjian",
    ja: "/kinou-yokyu/sakusei",
    ko: "/gineung-yoggu/geoljeong",
    id: "/permintaan-fitur/buat",
    tr: "/ozellik-talepleri/olustur",
    hu: "/funkcio-kerelemek/letrehoz",
    pl: "/zgloszenia-funkcji/utworz",
  },
  "/bug-reports/create": {
    en: "/bug-reports/create",
    de: "/fehlerberichte/erstellen",
    fr: "/rapports-bugs/creer",
    es: "/informes-errores/crear",
    pt: "/relatorios-bugs/criar",
    it: "/segnalazioni-bug/crea",
    nl: "/bug-rapporten/aanmaken",
    ru: "/otchety-ob-oshibkah/sozdat",
    ar: "/taqrirat-alashkal/ansh",
    hi: "/bug-raport/banaye",
    zh: "/bug-baogao/chuangjian",
    ja: "/bagu-repo/sakusei",
    ko: "/bagu-ripo/geoljeong",
    id: "/laporan-bug/buat",
    tr: "/bug-raporlari/olustur",
    hu: "/hiba-jelentesek/letrehoz",
    pl: "/raporty-bugow/utworz",
  },
  "/affiliate": {
    en: "/affiliate",
    de: "/affiliate",
    fr: "/affilie",
    es: "/afiliado",
    pt: "/afiliado",
    it: "/affiliato",
    nl: "/affiliate",
    ru: "/partner",
    ar: "/sharik",
    hi: "/sahayogi",
    zh: "/guanlian",
    ja: "/afirieito",
    ko: "/jeonhyeol",
    id: "/afiliasi",
    tr: "/ortak",
    hu: "/partner",
    pl: "/partner",
  },
  "/affiliate/claim": {
    en: "/affiliate/claim",
    de: "/affiliate/claim",
    fr: "/affilie/reclamer",
    es: "/afiliado/reclamar",
    pt: "/afiliado/reivindicar",
    it: "/affiliato/reclama",
    nl: "/affiliate/claim",
    ru: "/partner/claim",
    ar: "/sharik/claim",
    hi: "/sahayogi/claim",
    zh: "/guanlian/lingqu",
    ja: "/afirieito/claim",
    ko: "/jeonhyeol/claim",
    id: "/afiliasi/klaim",
    tr: "/ortak/talep",
    hu: "/partner/igenyles",
    pl: "/partner/odbierz",
  },
  "/affiliate/terms": {
    en: "/affiliate/terms",
    de: "/affiliate/terms",
    fr: "/affilie/conditions",
    es: "/afiliado/terminos",
    pt: "/afiliado/termos",
    it: "/affiliato/termini",
    nl: "/affiliate/terms",
    ru: "/partner/usloviya",
    ar: "/sharik/shurut",
    hi: "/sahayogi/sharten",
    zh: "/guanlian/tiaokuan",
    ja: "/afirieito/kiyaku",
    ko: "/jeonhyeol/yagwan",
    id: "/afiliasi/syarat",
    tr: "/ortak/sartlar",
    hu: "/partner/feltetelek",
    pl: "/partner/warunki",
  },
  "/how-it-works": {
    en: "/how-it-works",
    de: "/wie-es-funktioniert",
    fr: "/comment-ca-marche",
    es: "/como-funciona",
    pt: "/como-funciona",
    it: "/come-funziona",
    nl: "/hoe-het-werkt",
    ru: "/kak-eto-rabotaet",
    ar: "/kayf-yamal",
    hi: "/kaise-kaam-karta-hai",
    zh: "/ruhe-gongzuo",
    ja: "/douyatte-sayousuru",
    ko: "/eotteohge-jag-eonghaneunji",
    id: "/cara-kerjanya",
    tr: "/nasil-calisir",
    hu: "/hogyan-mukodik",
    pl: "/jak-to-dziala",
  },
  "/about": "/about",
  "/contact": "/contact",
  "/blog": "/blog",
  "/blog/[slug]": "/blog/[slug]",
  "/wisdom": "/wisdom",
  "/wisdom/[collectionId]": "/wisdom/[collectionId]",
  "/onboarding/signin": "/onboarding/signin",
  "/onboarding/offer": "/onboarding/offer",
  "/onboarding/how-to-use": "/onboarding/how-to-use",
  "/auth/mobile-callback": "/auth/mobile-callback",
  "/connectors": "/connectors",
  "/connectors/consent": "/connectors/consent",
  "/youtube-summarizer": "/youtube-summarizer",
  "/youtube-summary-chatgpt": "/youtube-summary-chatgpt",
  "/youtube-transcript": "/youtube-transcript",
  "/youtube-transcript-api": "/youtube-transcript-api",
  "/dashboard/api": "/dashboard/api",
  "/dashboard/library": "/dashboard/library",
  "/dashboard/subscriptions": "/dashboard/subscriptions",
  "/collection/[collectionId]": "/collection/[collectionId]",
  "/notifications": "/notifications",
  "/recap/[recapId]": "/recap/[recapId]",
};
